
import { Component, ChangeDetectionStrategy } from '@angular/core';
import type { ZoomResultsColumnCellRendererParams } from '@nts/std/interfaces';
import { AgRendererComponent } from 'ag-grid-angular';
// create your cellEditor as a Angular component
@Component({
    template: `
        @if (this.params?.data) {
          <div>
            {{ value }}
          </div>
        } @else {
          <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        }
        `,
    selector: 'nts-zoom-results-default-cell-renderer',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class ZoomResultsDefaultCellRendererComponent implements AgRendererComponent {
    params: ZoomResultsColumnCellRendererParams;
    refresh(params: any): boolean {
        return true;
    }
    agInit(params: ZoomResultsColumnCellRendererParams): void {
        this.params = params;
    }
    get value() {
        return this.params.data[Number.parseInt(this.params.colDef.field, 10)];
    }
}
